import { Activity } from 'lucide-react';
import { SessionActiveEvent as SessionActiveEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: SessionActiveEventType;
}

export default function SessionActiveEvent({ event }: Props) {
  return (
    <EventShell
      color="blue"
      icon={<Activity className="w-3.5 h-3.5" />}
      title="Session Active"
      timestamp={event.created_at}
    >
      <p>Visitor became active</p>
    </EventShell>
  );
}
